var N = Object.defineProperty;
var t = Object.getOwnPropertySymbols;
var i = Object.prototype.hasOwnProperty, m = Object.prototype.propertyIsEnumerable;
var n = (s, a, o) => a in s ? N(s, a, { enumerable: !0, configurable: !0, writable: !0, value: o }) : s[a] = o, r = (s, a) => {
  for (var o in a || (a = {}))
    i.call(a, o) && n(s, o, a[o]);
  if (t)
    for (var o of t(a))
      m.call(a, o) && n(s, o, a[o]);
  return s;
};
var c = (s, a) => {
  var o = {};
  for (var e in s)
    i.call(s, e) && a.indexOf(e) < 0 && (o[e] = s[e]);
  if (s != null && t)
    for (var e of t(s))
      a.indexOf(e) < 0 && m.call(s, e) && (o[e] = s[e]);
  return o;
};
import { jsx as v } from "react/jsx-runtime";
import "react";
import { f as B, u as P, B as S } from "./factory-ueRxoNOV.js";
import { u as g } from "./use-styles-DToiHEa6.js";
var p = { root: "m_515a97f8" };
const h = {}, d = B((s, a) => {
  const o = P("VisuallyHidden", h, s), l = o, { classNames: e, className: u, style: y, styles: f, unstyled: V, vars: j } = l, H = c(l, ["classNames", "className", "style", "styles", "unstyled", "vars"]), x = g({
    name: "VisuallyHidden",
    classes: p,
    props: o,
    className: u,
    style: y,
    classNames: e,
    styles: f,
    unstyled: V
  });
  return /* @__PURE__ */ v(S, r(r({ component: "span", ref: a }, x("root")), H));
});
d.classes = p;
d.displayName = "@mantine/core/VisuallyHidden";
export {
  d as V
};
